<div class="row filter-collapse" #filterCollapse>
    <div class="col-12">
        <div class="row">
            <div class="form-group col-12 col-md-4">
                <label for="codigoIntegracaoErp" class="col-form-label">Código ERP</label>
                <input type="text" class="form-control" [(ngModel)]="filter.codigoIntegracaoErp" name="codigoIntegracaoErp" id="codigoIntegracaoErp"
                    (ngModelChange)="isFilterDirty = true;">
            </div>            
            <div class="form-group col-12 col-md-4">
                <label for="cnpjCpf" class="col-form-label">CNPJ/CPF</label>
                <input type="text" class="form-control" [(ngModel)]="filter.cnpjCpf" name="cnpjCpf" id="cnpjCpf"
                    (ngModelChange)="isFilterDirty = true;">
            </div>            
            <div class="form-group col-12 col-md-4" *ngIf="!situacao">
                <label for="situacao" class="col-form-label">Situação</label>
                <select class="form-control" name="situacao" id="situacao" 
                    [ngModel]="filter.situacao || ''" (ngModelChange)="filter.situacao = $event ? $event : null; isFilterDirty = true;">
                    <option value="">Todas as situações</option>
                    <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                </select>  
            </div>                                                                       
        </div>  
        <div class="row">
            <div class="form-group col-12 col-md-3">
                <label for="dataCadastroInicial" class="col-form-label">Cadastro Inicial</label>
                <sgt-datepicker [(ngModel)]="filter.dataCadastroInicial" name="dataCadastroInicial" id="dataCadastroInicial"
                    #dataCadastroInicial="ngModel" [ngControl]="dataCadastroInicial" (ngModelChange)="onChangeDataCadastro($event)">
                </sgt-datepicker>                        
            </div>
            <div class="form-group col-12 col-md-3">
                <label for="dataCadastroFinal" class="col-form-label">Cadastro Final</label>
                <sgt-datepicker [(ngModel)]="filter.dataCadastroFinal" name="dataCadastroFinal" id="dataCadastroFinal"
                    #dataCadastroFinal="ngModel" [ngControl]="dataCadastroFinal" (ngModelChange)="onChangeDataCadastro($event)">
                </sgt-datepicker>                        
            </div>            
        </div>       
    </div>
</div>